export const performance = {
  primary: "#0A8560",
  secondary: "#B6DACF",
  tertiary: "#E7F3EF",
};
